(ns kyber.styles.media-queries)

(def queries {:mobile-portrait*
              "@media (min-width: 0px) and (max-width: 639px)"

              :mobile-landscape*
              "@media (min-width: 640px) and (max-width: 819px)"

              :tablet-portrait*
              "@media (min-width: 820px) and (max-width: 1023px)"

              :tablet-landscape*
              "@media (min-width: 1024px) and (max-width: 1227px)"

              :desktop-plus*
              "@media (min-width: 1228px)"

              :mobile-portrait
              "@media (max-width: 639px)"

              :mobile-landscape
              "@media (max-width: 819px)"

              :tablet-portrait
              "@media (max-width: 1023px)"

              :tablet
              "@media (max-width: 1227px)"

              :hover
              "@media (hover: hover)"

              :ie
              (str "@media all and (-ms-high-contrast: none), "
                   "(-ms-high-contrast: active)")

              :touch-screen
              "@media (pointer: coarse) and (hover: none)"

              :print
              "@media print"})
